import React from 'react';
import { Sparkles } from 'lucide-react';
export function TopBar() {
  return <div className="sticky top-0 z-50 w-full bg-[#292524] text-[#FDFBF7] py-3 px-4 text-center text-sm md:text-base font-medium shadow-md" data-id="element-214">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-2" data-id="element-215">
        <Sparkles className="w-4 h-4 text-[#DFB76C] shrink-0" data-id="element-216" />
        <p data-id="element-217">
          <span className="hidden sm:inline" data-id="element-218">Es tu momento de florecer. </span>
          Desbloquea el acceso al sistema completo con un{' '}
          <strong className="text-[#DFB76C]" data-id="element-219">70% de descuento</strong> solo por
          las próximas 24 horas.
        </p>
      </div>
    </div>;
}